/* eslint-disable  @typescript-eslint/no-explicit-any */

import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'

import { getRepeatedPaymentPeriodSelector } from 'Redux/selectors/analytics'
import { getRepeatedPaymentPeriod } from 'Redux/actions/analyticsActions'

import { TotalPaymentPeriod } from './types'
import { ArtistsPaymentPeriod } from './ArtistsPaymentPeriod'

type ArtistsRepeatedPaymentPeriodProps = {
  repeatedPaymentPeriod: TotalPaymentPeriod
  handleGetRepeatedPaymentPeriod: (pickerRanges: string) => void
  pickerRanges: string
}

const ArtistsRepeatedPaymentPeriod: React.FunctionComponent<ArtistsRepeatedPaymentPeriodProps> = ({
  repeatedPaymentPeriod,
  handleGetRepeatedPaymentPeriod,
  pickerRanges,
}) => (
  <ArtistsPaymentPeriod
    paymentPeriod={repeatedPaymentPeriod}
    handleGetPaymentPeriod={handleGetRepeatedPaymentPeriod}
    pickerRanges={pickerRanges}
  />
)

const selector = createStructuredSelector({
  repeatedPaymentPeriod: getRepeatedPaymentPeriodSelector,
})

const actions = {
  handleGetRepeatedPaymentPeriod: getRepeatedPaymentPeriod,
}

export default compose<any>(connect(selector, actions))(
  ArtistsRepeatedPaymentPeriod
)
